/** Portal roles allowed to use service-visit scheduling customer lookup. */
export const SERVICE_VISIT_SCHEDULING_ROLES = [
  "admin",
  "service",
  "programming",
  "installer",
  "sales",
  "finance",
] as const;

export type ServiceVisitSchedulingRole = (typeof SERVICE_VISIT_SCHEDULING_ROLES)[number];

export type ServiceVisitCustomerPick = {
  id: number;
  name: string;
  contact: string | null;
  email: string | null;
  address: string | null;
  unitNumber: string | null;
  postalCode: string | null;
};

export function canScheduleServiceVisit(role: string): boolean {
  const normalized = String(role ?? "").trim().toLowerCase();
  return (SERVICE_VISIT_SCHEDULING_ROLES as readonly string[]).includes(normalized);
}

export function toServiceVisitCustomerPick(c: {
  id: number;
  name: string;
  contact?: string | null;
  email?: string | null;
  address?: string | null;
  unitNumber?: string | null;
  postalCode?: string | null;
}): ServiceVisitCustomerPick {
  return {
    id: c.id,
    name: c.name,
    contact: c.contact ?? null,
    email: c.email ?? null,
    address: c.address ?? null,
    unitNumber: c.unitNumber ?? null,
    postalCode: c.postalCode ?? null,
  };
}
